import { useTranslation } from "react-i18next";
import useStyles from "./style";
import calendarh from "../../assets/img/calendar_h.jpg";
import arispot from "../../assets/img/arispot.jpg";
import simplifreelanceagency from "../../assets/img/simplifreelanceagency.jpg";
import movia from "../../assets/img/movia.jpg";
import { Send, Warning } from "../../assets/svg";
import { useEffect, useState } from "react";

const Projects = () => {
    const style = useStyles();
    const { t } = useTranslation();

    const [isActive, setIsActive] = useState(false);
    const [link, setLink] = useState("");
    const [name, setName] = useState("");

    useEffect(() => {
        const elements = document.querySelectorAll(`.${style.items}`);
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(style.animateIn);
                    entry.target.classList.remove(style.animateOut);
                } else {
                    entry.target.classList.remove(style.animateIn);
                    entry.target.classList.add(style.animateOut);
                }
            });
        }, { threshold: 0.1 });

        elements.forEach(element => observer.observe(element));

        return () => {
            elements.forEach(element => observer.unobserve(element));
        };
    }, [style]);

    useEffect(() => {
        if (isActive) {
            document.body.classList.add(style.bodyClass);
        } else {
            document.body.classList.remove(style.bodyClass);
        }

        return () => {
            document.body.classList.remove(style.bodyClass);
        };
    }, [isActive]);

    const openWarning = (newLink: string, newName: string) => {
        setLink(newLink);
        setName(newName);
        setIsActive(true);
    };

    const closeShow = () => {
        setIsActive(false);
    };

    const handleContinue = () => {
        window.open(link, "_blank");
        setIsActive(false);   // 👈 Սա փակում է warning-ը
    };

    return (
        <section className={style.projects}>
            <h1>{t("Projects")}</h1>

            <div>
                {/* CalendarH */}
                <div className={style.items}>
                    <div className={style.txt}>
                        <p>Picsart Academy (Code Republic Lab)</p>
                        <h2>CalendarH</h2>
                        <div className={style.title}>{t("CalendarH")}</div>
                    </div>
                    <div className={`${style.img} ${style.calendarh}`}>
                        <img src={calendarh} alt="CalendarH" />
                    </div>
                </div>

                {/* Arispot */}
                <div className={style.items}>
                    <div className={`${style.img} ${style.arispot}`}>
                        <img src={arispot} alt="Arispot" />
                    </div>
                    <div className={style.txt}>
                        <p>Picsart Academy (Code Republic Lab)</p>
                        <h2>Arispot</h2>
                        <div className={style.title}>{t("Arispot")}</div>
                    </div>
                </div>

                {/* Movia */}
                <div className={style.items}>
                    <div className={`${style.txt} ${style.top}`}>
                        <p>Picsart Academy (Code Republic Lab)</p>
                        <h2>Movia.TO</h2>
                        <div className={style.title}>{t("Movia")}</div>
                    </div>
                    <div className={`${style.img} ${style.movia} ${style.top}`}>
                        <img src={movia} alt="Movia.TO" />
                    </div>
                </div>

                {/* SIMPLI */}
                <div className={style.items}>
                    <div className={`${style.img} ${style.simplifreelanceagency}`}>
                        <img src={simplifreelanceagency} alt="SIMPLI Freelance Agency" />
                    </div>
                    <div className={style.txt}>
                        <p>SIMPLI Freelance Agency</p>
                        <h2>SIMPLI Freelance Agency</h2>
                        <div className={style.title}>{t("SIMPLIFreelanceAgency")}</div>
                        <div 
                          className={style.link} 
                          onClick={() => openWarning(
                              "https://simplifreelanceagency.netlify.app", 
                              "SIMPLI Freelance Agency"
                          )}
                        >
                            <Send />
                        </div>
                    </div>
                </div>
            </div>

            {/* Qendly */}
            <div className={style.items}>
                <div className={`${style.txt} ${style.top}`}>
                    <p>Erik Greyan</p>
                    <h2>Qendly</h2>
                    <div className={style.title}>{t("Qendly")}</div>
                    <div 
                      className={style.link} 
                      onClick={() => openWarning("https://www.qendly.com", "Qendly")}
                    >
                        <Send />
                    </div>
                </div>
                <div className={`${style.img} ${style.qendly} ${style.top}`}>
                    <img 
                      src="https://www.qendly.com/share.jpg" 
                      alt="Qendly.com" 
                    />
                </div>
            </div>

            {/* ===== WARNING MODAL ===== */}
            <div className={`${style.show} ${isActive ? style.active : ""}`}>
                <div className={style.style}>
                    <div className={style.info}>
                        <Warning />
                        <p>
                            {t("Warning1")} <b>{name}</b> {t("Warning2")}
                        </p>

                        <div>
                            <button
                                className={`${style.button} ${style.close}`}
                                onClick={closeShow}
                            >
                                {t("Cancel")}
                            </button>

                            <button
                                className={`${style.button} ${style.open}`}
                                onClick={handleContinue}
                            >
                                {t("Continue")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Projects;
